import { ActionContext, ActionTree, GetterTree } from 'vuex';

export interface State {
  staffModal: boolean;
}

const initialState: State = {
  staffModal: false,
};

const actions: ActionTree<State, any> = {
  openStaffModal({ commit }: ActionContext<State, any>): void {
    commit('openStaffModal');
  },
  closeStaffModal({ commit }: ActionContext<State, any>): void {
    commit('closeStaffModal');
  },
};

const mutations = {
  openStaffModal(state: State) {
    state.staffModal = true;
  },
  closeStaffModal(state: State) {
    state.staffModal = false;
  },
};

const getters: GetterTree<State, any> = {
  staffModal(state): boolean {
    return state.staffModal;
  },
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: initialState,
  getters,
  actions,
  mutations,
};
